"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CaretUpCircleIcon = _interopRequireDefault(require("../../../../icons/standard-icons/CaretUpCircleIcon"));

var _CaretDownCircleIcon = _interopRequireDefault(require("../../../../icons/standard-icons/CaretDownCircleIcon"));

var _Tooltip = _interopRequireDefault(require("../../../../help/Tooltip/Tooltip"));

var _styles = require("./styles");

var _hooks = require("./hooks");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ToolbarPageNav = ({
  currentPage,
  numPages,
  onPageNumberChange,
  options,
  tooltip
}) => {
  const {
    page,
    gotoNextPage,
    gotoPreviousPage,
    maxPages,
    handleInputKeyDown,
    handleInputChange,
    handleInputBlur,
    focusInput,
    pageInputRef,
    pageEditRef,
    tooltipId,
    pageEditNavClass
  } = (0, _hooks.useToolbarPageNav)({
    currentPage,
    numPages,
    onPageNumberChange
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledToolbarPageNav, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PreviousPageButton, {
      className: "document-toolbar-page-nav__previous-page",
      tooltip: "Previous page",
      onClick: gotoPreviousPage,
      disabled: currentPage === 1,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CaretUpCircleIcon.default, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.PageNavEdit, {
      ref: pageEditRef,
      "data-tip": tooltip,
      "data-for": tooltipId,
      className: pageEditNavClass,
      options: options,
      onClick: focusInput,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PageNavEditInput, {
        "aria-label": "Page number",
        type: "text",
        ref: pageInputRef,
        value: page,
        tabIndex: "-1",
        maxLength: maxPages,
        onKeyDown: handleInputKeyDown,
        onChange: handleInputChange,
        onBlur: handleInputBlur
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PageNavSeparator, {
        children: "/"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PageNavTotalPages, {
        "aria-label": "Total pages",
        children: numPages
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
      id: tooltipId,
      delayShow: 1000,
      delayHide: 0
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.NextPageButton, {
      className: "document-toolbar-page-nav__next-page",
      tooltip: "Next page",
      onClick: gotoNextPage,
      disabled: currentPage === numPages,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CaretDownCircleIcon.default, {
        title: "Next page"
      })
    })]
  });
};

ToolbarPageNav.defaultProps = {
  options: {},
  tooltip: 'Click to jump to a page'
};
ToolbarPageNav.propTypes = {
  currentPage: _propTypes.default.number.isRequired,
  numPages: _propTypes.default.number.isRequired,
  onPageNumberChange: _propTypes.default.func.isRequired,
  options: _propTypes.default.object,
  tooltip: _propTypes.default.string
};
var _default = ToolbarPageNav;
exports.default = _default;